<a *ngIf="showContactShortcut" pTooltip="Nous contacter" tooltipPosition="left" style="cursor: pointer" class="layout-config-button" (click)="goNousContacter()">
    <i id="icon-contact" class="pi pi-phone"></i>
</a>
